<template>
  <div class="maincontent">
    <the-header />
    <div class="menucontent">
      <Menu></Menu>
      <div class="mainpage">
        <router-view></router-view>
      </div>
    </div>
<!--    <the-footer />-->
  </div>
</template>
<script type="es6">
import menu from "./Menu";
import {mapState} from "vuex";
import Cookies from "js-cookie";
import { debounce } from 'lodash'
import TheHeader from "./TheHeader.vue";
import TheFooter from "./TheFooter.vue";


export default {
  components: {
    TheFooter,
    TheHeader,
    "Menu": menu,
  },
  computed: {
    ...mapState({
      menuwidth: state => state.menuwidth
    })
  },
  methods: {
    setHeight: debounce(function () {
      document.getElementsByClassName('maincontent')[0].style.height = "calc(100vh - 116px)";
      document.getElementsByClassName('mainpage')[0].style.height = "calc(100vh - 116px)";
      document.getElementsByClassName('ruijie-menu')[0].style.height = "calc(100vh - 116px)";
    }, 1000),
  },
  mounted () {
    this.setHeight();
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "../../styles/variables";


.maincontent {
  height: 100%;
  position: relative;
  .menucontent {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    transition: height 0.4s;
    -moz-transition: height 0.4s; /* Firefox 4 */
    -webkit-transition: height 0.4s; /* Safari 和 Chrome */
    -o-transition: height 0.4s; /* Opera */
    .ruijie-menu {
      overflow-y: auto;
      height: 100%;
      background: #fff;
      left: 0;
      z-index: 100;
      transition: width 0.4s;
      -moz-transition: width 0.4s; /* Firefox 4 */
      -webkit-transition: width 0.4s; /* Safari 和 Chrome */
      -o-transition: width 0.4s; /* Opera */
      border-right: 1px solid #ebebeb;
      border-top: none;
      .menuborder {
        position: fixed;
        width: 1px;
        height: 100%;
        background: #ebebeb;
        top: 0;
        transition: left 0.4s;
        -moz-transition: left 0.4s; /* Firefox 4 */
        -webkit-transition: left 0.4s; /* Safari 和 Chrome */
        -o-transition: left 0.4s; /* Opera */

      }
    }

    .mainpage {
      //margin-left: 200px;
      height: 100%;
      flex: 1;
      overflow-y: auto;
      padding: 20px 45px 100px;

      transition: margin-left 0.4s;
      -moz-transition: margin-left 0.4s; /* Firefox 4 */
      -webkit-transition: margin-left 0.4s; /* Safari 和 Chrome */
      -o-transition: margin-left 0.4s; /* Opera */
    }
  }
}

.el-submenu__title {
  padding-right: 40px;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/ContentMenu.vue